import { Component, Inject, OnInit } from "@angular/core";

import { DatasetListingService } from "src/app/dataset-listing/dataset-listing.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DatasetInfo } from "./timeseries-picker-dialog.data";
import { generateTimeSeriesSets, getDateFormattedBasedOnPeriodicity, createPeriodicity } from "@models/mood/helpers/timeseries";
import { TimeSeriesMetadata } from "@models/mood/metadata";
import { parse } from "date-fns";
import { TimeseriesStateService } from "src/app/core/timeseries-state.service";
import { LayerListService } from "src/app/core/layer-list.service";
import { Dataset, TimeSeriesDataset } from "@models/mood/dataset";


@Component({
  selector: 'mood-timeseries-picker-dialog',
  templateUrl: 'timeseries-picker-dialog.component.html',
  styleUrls: ['timeseries-picker-dialog.component.scss']
})
export class TimeseriesPickerDialogComponent implements OnInit {
  private timeseriesList: Date[] = [];

  minDate: Date | null = null;
  maxDate: Date | null = null;

  startDate: Date | null = null;
  endDate: Date | null = null;


  loaded = false;

  private _dataset!: TimeSeriesDataset;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DatasetInfo,
    private _dialogRef: MatDialogRef<TimeseriesPickerDialogComponent>,
    private _dataListingService: DatasetListingService,
    private _timeseriesStateService: TimeseriesStateService,
    private _layerListService: LayerListService
  ) { }


  async ngOnInit() {
    await this.generateTimeSeriesList();

    this.loaded = true;
  }

  public async generateTimeSeriesList() {
    this._dataset = (await this._dataListingService.findDatasetById(this.data.dataset_id))! as TimeSeriesDataset;

    this.minDate = parse(this._dataset.metadata.start_date, this._dataset.metadata.date_formats!, new Date());
    this.maxDate = parse(this._dataset.metadata.end_date, this._dataset.metadata.date_formats!, new Date());

    let timeline = generateTimeSeriesSets(this._dataset?.metadata);

    this.timeseriesList = timeline;
  }

  timeseriesFilter = (d: Date | null): boolean => {
    return this.timeseriesList.some(date => date.getTime() == d!.getTime());
  };

  async addDataset() {
    const periodicity = createPeriodicity(this._dataset.metadata.periodicity_days, this._dataset.metadata.periodicity_months, this._dataset.metadata.periodicity_weeks, this._dataset.metadata.periodicity_days)
    this._layerListService.notifyRasterLayerAdded(this._dataset, {
      layer_id: this.startDate!.getTime().toString(),
      layer_name: getDateFormattedBasedOnPeriodicity(this.startDate!, periodicity)
    });

    if (this.endDate) {
      this._layerListService.notifyRasterLayerAdded(this._dataset, {
        layer_id: this.endDate!.getTime().toString(),
        layer_name: getDateFormattedBasedOnPeriodicity(this.endDate!, periodicity)
      });
    }

    this._timeseriesStateService.updateDates(this.startDate!, this.endDate ?? undefined);

    if (this.endDate && !this._timeseriesStateService.isTimeseriesVisible.value) {
      this._timeseriesStateService.toggleTimeseriesVisible(true);
    }
    this._dialogRef.close();
  }
}
